import Link from 'next/link';
import { tv } from 'tailwind-variants';

const linkStyles = tv({
  base: 'no-underline hover:no-underline',
  variants: {
    fullSize: {
      true: 'flex h-full w-full items-center',
      false: 'w-fit'
    }
  },
  defaultVariants: {
    fullSize: false
  }
});

interface WithLinkConfig {
  href: string | undefined;
  disabled?: boolean;
  fullSize?: boolean;
  key?: string;
  newTab?: boolean;
}

const withLink = (
  Component: React.ReactElement,
  config: WithLinkConfig
): React.ReactElement => {
  const {
    href,
    key,
    disabled = false,
    newTab = false,
    fullSize = false
  } = config;

  return !!href && !disabled ? (
    <Link
      className={linkStyles({ fullSize })}
      data-testid="with-link-wrapper"
      href={href}
      key={key}
      target={newTab ? '_blank' : '_self'}
    >
      {Component}
    </Link>
  ) : (
    Component
  );
};

export default withLink;
